import clsx from "clsx";
import { useMetricStack } from "./useMetricStack";
import { MetricQuery } from "./metrics.types";
import { useMetricQuery } from "./useMetricQuery";
import { getMetricName } from "./helpers/getMetricName";
import { describeWindowOperation } from "./helpers/getWindowDescription";

export const MetricList = () => {
    const { stack } = useMetricStack();
    const { setCurrentMetricQuery, currentMetricQuery, removeWindow } =
        useMetricQuery();

    return (
        <div
            className={clsx(
                " h-full",
                "flex flex-col",
                "min-h-0 overflow-hidden",
            )}
        >
            <ul
                className={clsx(
                    "flex flex-1 flex-col",
                    "hide-scrollbar min-h-0 gap-2 overflow-y-auto",
                )}
            >
                {stack.map((metricQuery: MetricQuery) => (
                    <li
                        className={clsx(
                            "card flex flex-col gap-2",
                            metricQuery.metricQuery ===
                                currentMetricQuery.metricQuery && "selected",
                        )}
                        key={metricQuery.metricQuery}
                        onClick={() => {
                            if (currentMetricQuery.window) {
                                removeWindow();
                            }
                            setCurrentMetricQuery(metricQuery);
                        }}
                    >
                        <div className="subdued cursor-pointer">
                            <div className="flex cursor-pointer flex-col gap-2">
                                <p className="body-s cursor-pointer break-all pr-1">
                                    {getMetricName(metricQuery)}
                                </p>
                                <p className="body-m subdued cursor-pointer pt-1">
                                    {describeWindowOperation(metricQuery) ||
                                        "All periods"}
                                </p>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};
